var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._m(0),_c('div',{staticClass:"md-layout"},[_c('AdminbLock',{attrs:{"name":'restaurant-api'}})],1)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"header text-center"},[_c('h3',{staticClass:"title"},[_vm._v("ADMIN")])])
}]

export { render, staticRenderFns }